import { ajax } from '../../../services/helper'
class ApiService {

    getKitchensData = (city_id,cluster_id) => {
        
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/list?city_id="+city_id+"&cluster_id="+cluster_id
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            }) 
        
        
    }

    getKitchensDataById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }   


    getBrandGroupsCombo = () =>{
             return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    




    addKitchen = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


        editKitchen = (data,id) => {
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/"+id+"/update"
                ajax(url,'POST', data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }

        updateWorkStation = (data,id) => {
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/"+id+"/updateStaff"
                ajax(url,'POST', data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }

        


    getKitchensTeamDataById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/"+id+"/listTeam"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Kitchens/services/apiservices.js